import React from 'react';
import { Modal, PaperTitle, Button, ButtonsContainer } from 'virtues-bootstrap';
import PropTypes from 'prop-types';

const DeleteReport = ({ handleHide, handleRemoveClick, show }) => (
  <Modal show={show ? 1 : 0}>
    <PaperTitle size="md" withBorder>
      Are you sure to remove this report?
      <ButtonsContainer wrapped>
        <Button onClick={handleHide}>Cancel</Button>
        <Button variant="danger" onClick={handleRemoveClick}>
          Remove
        </Button>
      </ButtonsContainer>
    </PaperTitle>
  </Modal>
);

DeleteReport.propTypes = {
  show: PropTypes.bool.isRequired,
  handleHide: PropTypes.func.isRequired,
  handleRemoveClick: PropTypes.func.isRequired,
};

export default DeleteReport;
